import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import { PageElement } from './Page';

const Member = lazy(() =>
    import('@/v1/auth/views/Member').then((module) => ({
        default: module.Member,
    }))
);

const Department = lazy(() =>
    import('@/v1/auth/views/Department').then((module) => ({
        default: module.Department,
    }))
);

const DepartmentGroup = lazy(() =>
    import('@/v1/auth/views/DepartmentGroup').then((module) => ({
        default: module.DepartmentGroup,
    }))
);

const User = lazy(() =>
    import('@/v1/auth/views/User').then((module) => ({
        default: module.User,
    }))
);

const UserGroup = lazy(() =>
    import('@/v1/auth/views/UserGroup').then((module) => ({
        default: module.UserGroup,
    }))
);

export const userSettingRoutes: RouteObject[] = [
    {
        path: `member`,
        ...PageElement(<Member />),
    },
    {
        path: `department`,
        ...PageElement(<Department />),
    },
    {
        path: `department_group`,
        ...PageElement(<DepartmentGroup />),
    },
    {
        path: `user`,
        ...PageElement(<User />),
    },
    {
        path: `user_group`,
        ...PageElement(<UserGroup />),
    },
];
